import { useState, useEffect } from "react";
import { BoldifyReplace } from "../../Statblock/BoldifyReplace.js";
import OptionButton from "../../EncounterColumn/OptionButton.js";
import showcaseImg from "../../../pics/icons/showcase.png";
import folderImg from "../../../pics/icons/folder.png";
import { generateUniqueId } from "../../../constants.js";
import { useUser } from '../../../../../../providers/UserProvider.js';
import { useImages } from '../../../../../../providers/ImagesProvider.js';

const BookSection = ({ content, label, page, autoOpen = false, cKey = "", bottom, handleSearchSelectCreature, socket}) => {
    const [isOpen, setIsOpen] = useState(autoOpen);
    const [firstOpen, setFirstOpen] = useState(true);
    const [showCaseMessage, setShowCaseMessage] = useState(false);
    const [showCaseKill, setShowCaseKill] = useState(false);

    const { username } = useUser();

    const { 
        setShowcases,
        setShowCaseGlow,
        playerViewSharedImage, setPlayerViewSharedImage
    } = useImages();
    

    const toggleOpen = () => setIsOpen(open => !open);

    useEffect(() => {
        // If section is opened save it
        if (isOpen) {
            localStorage.setItem(`booksection-${cKey}.${label}`, true);
        } else {
            // secton closed - if first load check if it should be opened
            if(firstOpen) {
                const isSaved = localStorage.getItem(`booksection-${cKey}.${label}`);
                if(isSaved)
                    toggleOpen()

                setFirstOpen(false);
            } else { // if closed on subsequent loads, remove from storage
                localStorage.removeItem(`booksection-${cKey}.${label}`);
            }
        }
    }, [isOpen]);

    const shareImgClick = (imgUrl, action=undefined) => {
        let showcaseObj = {
            "type": "showcase",
            "imageGuid": generateUniqueId(),
            "username": username,
            "image": imgUrl
        }

        if(action === 'save') {
            // Save in backend and update from endarray
            socket.emit('uploadNewShowCaseImage', showcaseObj)
            setShowcases(prevShowcases => {
                return [{...showcaseObj}, ...prevShowcases]
            })
            setShowCaseMessage(true)
            setTimeout(() => {
                setShowCaseMessage(false)
                setShowCaseGlow(false)
            }, 8000)
        } else {
            socket.emit("sendQuickPvShowcase", showcaseObj)
            setPlayerViewSharedImage({type: "image", src: showcaseObj.image})
            setShowCaseKill(true)
        }

        setShowCaseGlow(true)
    };    
    
    const stopSharingImage = () => {
        setPlayerViewSharedImage(null)
        socket.emit('pvShowcaseKill')
        setShowCaseGlow(false)
    };

    useEffect(() => {
        if(!playerViewSharedImage)
            setShowCaseKill(false)
    }, [playerViewSharedImage])

    return (
        <li className='bookSectionItem' key={cKey}>
            {label && 
                <div className='bookListContainer bookListEntry' onClick={toggleOpen} 
                    style={{
                        borderBottom: bottom ? '2px solid black' : '',
                        marginBottom: bottom ? '3px' : '0px'
                    }} 
                >
                    <b>{label}</b> 
                    <div style={{cursor: 'pointer'}}>
                        {page && <i style={{fontSize: "small", marginRight: "5px"}}>p.{page}</i>}
                        <svg width="16" height="16" viewBox="0 0 16 16" style={{
                            verticalAlign: "middle",
                            transition: "transform 0.2s",
                            transform: isOpen ? "rotate(0deg)" : "rotate(90deg)"
                        }}>
                            <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            }
            <ul className='bookListUL'>
                {isOpen && content.map((entry, idx) => {
                    let bottomEntry = idx === content.length - 1;
                    let cKeyTag =  `${cKey}.${label}.${entry.type}.${idx}`
                    if (typeof entry === 'string') {
                        return (
                            <li className="bookListEntry" key={cKeyTag}
                                style={{
                                    borderBottom: bottomEntry ? '3px solid black' : 'none',
                                    marginBottom: bottomEntry ? '5px' : '0px'
                                }}
                            >
                                <BoldifyReplace desc={entry} handleSearchSelectCreature={handleSearchSelectCreature}/>
                            </li>
                        );
                    } else if (typeof entry === 'object') {
                        if (entry.type === 'image') {
                            return (
                                <li className="bookListEntry bookListEntryImage" key={cKeyTag}
                                    style={{
                                        borderBottom: bottomEntry ? '5px solid black' : 'none',
                                        marginBottom: bottomEntry ? '5px' : '0px'
                                    }}
                                >
                                    {entry.title && <div style={{color: "black"}}><i>{entry.title}</i></div> }
                                    <img src={'https://5e.tools/img/' + entry.href.path} 
                                        width={100} height={100} alt={`${'Image: https://5e.tools/img/' + entry?.href?.path}`}
                                        onClick={() => window.open('https://5e.tools/img/' + entry.href.path, '_blank')}
                                        style={{ cursor: 'pointer', outline: '1px solid black' }}
                                    />
                                    <div style={{display: 'flex'}}>
                                        {showCaseKill && <OptionButton src={showcaseImg} imgStyle={{border: "2px solid red"}} message={`Stop Sharing Image`} onClickFunction={stopSharingImage}/>}
                                        <OptionButton src={showcaseImg} imgStyle={{border: "2px solid black"}} message={`Quick Share to PlayerView`} onClickFunction={() => shareImgClick('https://5e.tools/img/' + entry.href.path)} />
                                        <OptionButton src={folderImg} imgStyle={{border: "2px solid black"}} message={`Save to Showcases`} onClickFunction={() => shareImgClick('https://5e.tools/img/' + entry.href.path, 'save')} />
                                    </div>
                                    {showCaseMessage && <i>Saved image to Showcases</i>}
                                    {entry.credit && <div style={{color: "black", fontSize: "small"}}><i>Image Credit: {entry.credit}</i></div>}
                                </li> 
                            );
                        } else if (['section', 'inset', 'entries', 'inset', 'insetReadaloud', 'quote', 'item'].includes(entry.type)) {
                            return <BookSection key={cKeyTag} content={entry.entries} label={entry.name} page={entry.page} autoOpen={!!!entry.name} cKey={cKeyTag} bottom={bottomEntry} handleSearchSelectCreature={handleSearchSelectCreature} socket={socket}/>
                        } else if (entry.type === 'list') {
                            return <BookSection key={cKeyTag} content={entry.items} page={entry.page} autoOpen={true} cKey={cKeyTag} bottom={bottomEntry} handleSearchSelectCreature={handleSearchSelectCreature} socket={socket}/>
                        } else if (entry.type === 'gallery') {
                            return <BookSection key={cKeyTag} content={entry.images} page={entry.page} cKey={cKeyTag} bottom={bottomEntry} handleSearchSelectCreature={handleSearchSelectCreature} socket={socket}/>
                        }  
                        else if (entry.type === "table") {
                            return (
                                <table className='spellTable'>
                                    {entry.colLabels &&
                                        <tr>
                                            {entry.colLabels.map((label) => {
                                                return <th><BoldifyReplace desc={label} handleSearchSelectCreature={handleSearchSelectCreature}/></th>
                                            })}
                                        </tr>
                                    }
                                    {entry.rows.map((row) => {
                                        return (
                                            <tr>
                                                {row.map((rowData, index) => {
                                                    return <td className={index ? "" : "spellTableDice"}><BoldifyReplace desc={rowData} handleSearchSelectCreature={handleSearchSelectCreature}/></td>
                                                })}
                                            </tr>
                                        )
                                    })}
                                </table>
                            )
                        } else {
                            return <b>If you are seeing this let nic know on discord :)</b>
                        }
                        
                    } else {
                        return null;
                    }
                })}
            </ul>
         
        </li>
    );
};

export default BookSection;